import cn from 'classnames'

import Checkbox from 'components/Checkbox'
import CheckboxIndeterminate from 'components/CheckboxIndeterminate'

const CheckboxTree = ({
  parentLabel,
  parentUuid,
  children,
  parentChecked,
  indeterminate,
  childrenChecked,
  handleChangeCheckbox,
}) => {
  return (
    <div className="checkbox-tree">
      <div className="checkbox-tree__parent" key={parentUuid}>
        <CheckboxIndeterminate
          label={parentLabel}
          checked={parentChecked}
          indeterminate={indeterminate}
          handleChange={() => handleChangeCheckbox(parentUuid)}
          className={cn('-bold', { '-active': parentChecked })}
        />
        {children?.map(({ name, uuid }) => {
          return (
            <div className="checkbox-tree__children" key={uuid}>
              <Checkbox
                label={name}
                checked={childrenChecked(uuid)}
                onChange={() =>
                  handleChangeCheckbox(uuid, parentUuid)
                }
                className={childrenChecked(uuid) && '-active'}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CheckboxTree
